export const HTTP_STATUS_CODE = {
  Forbidden: 403,
  RequestTimeout: 408,
  BadGateway: 502,
  BadRequest: 400,
  Unauthorized: 401,
};

// Operation context for callers that show their own error feedback: no takeover screen on timeouts and no generic global alert.
export const LOCAL_ERROR_HANDLING_CONTEXT = {
  skipTimeoutScreen: true,
  skipGenericErrorNotification: true,
};
